import styles from './style.module.css'

interface SpinnerProps {
  size?: number
  label?: string
}

const Spinner = ({ label, size = 24 }: SpinnerProps) => (
  <span
    className={styles.spinner}
    style={{ width: size, height: size }}
    role="status"
    aria-label={label ?? 'Carregando'}
  />
)

export default Spinner
